import { Environment, Store, RecordSource, Network } from 'relay-runtime';
import { getBuyerToken } from 'dibs-cookie-jar';
import serverVars from 'server-vars';
import { createFetcher } from 'dibs-relay-network-layer/client';

let environment;

export default function getRelayEnvironment(records = {}) {
    if (!environment) {
        const network = Network.create(
            createFetcher({
                getQueries: () => ({
                    ...getBuyerToken(document.cookie),
                    locale: serverVars.get('locale'),
                }),
            })
        );
        const source = new RecordSource(records);
        const store = new Store(source);
        environment = new Environment({ network, store });
    }
    return environment;
}



// WEBPACK FOOTER //
// ./src/relayClientEnvironment.js